<template>
	<div class="b-counter b-counter_catalog b-counter_productCard">
		<a href="javascript:void(0);" class="icon icon--minus b-counter__icon b-counter__icon_minus"
		   @click.prevent="decrease"></a>
		<div class="b-counter__inputWrap">
			<input class="b-counter__input" type="hidden" v-model="currentQuantity" :step="measure.ratio"
			       :min="0" :max="maxQuantity"
			       @input="update"
			>
			<span class="b-counter__value" v-html="currentQuantity"></span>
		</div>
		<a href="javascript:void(0);" class="icon icon--plus b-counter__icon b-counter__icon_plus"
		   @click.prevent="increase"></a>
	</div>
</template>
<script>
import "citrus.vuex.store";

export default {
	name: "CitrusProductBasketQuantityButton",
	store: BX.Citrus.Vuex.store,
	props: {
		productId: {
			type: [Number, String],
			default: ""
		},
		metricGoal: {
			type: [Boolean, String],
			default: false
		},
		measure: {
			type: Object,
			default: function () {
				return {
					name: "",
					ratio: 1,
				}
			}
		},
		initQuantity: {
			type: Number,
			default: 0
		},
		maxQuantity: {
			type: Number,
			default: 9999
		}
	},
	data: function () {
		return {
			currentQuantity: this.initQuantity,
			request: false,
			newRequestCount: 0,
		};
	},
	methods: {
		decrease: function () {
			this.update(true, false);
		},
		increase: function () {
			this.update(false, true);
		},
		update: function (checkDecrease, checkIncrease) {
			checkDecrease = !!checkDecrease;
			checkIncrease = !!checkIncrease;

			this.checkStepValue();
			if (checkDecrease) {
				this.checkMinValue();
			}
			if (checkIncrease) {
				this.checkMaxValue();
			}

			this.tryChangeQuantity();
		},
		checkMinValue: function () {
			if (this.currentQuantity >= this.measure.ratio) {
				this.currentQuantity -= this.measure.ratio;
			}
		},
		checkMaxValue: function () {
			if ((this.currentQuantity + this.measure.ratio) < this.maxQuantity) {
				this.currentQuantity += this.measure.ratio;
			}
		},
		checkStepValue: function () {
			if (this.currentQuantity % this.measure.ratio !== 0) {
				this.currentQuantity = Math.floor(this.currentQuantity / this.measure.ratio);
			}
		},
		tryChangeQuantity: function () {
			/* Если нет активных запросов */
			if (!this.request) {
				this.request = true;
			} else {
				this.newRequestCount++; /* счетчик одновременных запросов */
			}

			setTimeout(() => {
				/* К данному моменту есть новый запрос */
				if (this.newRequestCount) {
					this.newRequestCount--;
					return false;
				}

				/* отправка запроса */
				this.changeQuantity();
				this.request = false;
			}, 300);
		},
		changeQuantity: function () {
			if (this.currentQuantity == 0) {
				this.$store.dispatch("basket/remove", this.productId);
			} else {
				this.$store.dispatch("basket/change", {id: this.productId, quantity: parseInt(this.currentQuantity)});

				// отправим данные по метрике
				if (this.metricGoal) {
					this.$gtag.event(this.metricGoal);
					this.$metrika.reachGoal(this.metricGoal);
				}
			}
		},
	}
}
</script>